define('bizzabo/views/main/SponsorsView',[
    'jquery',
    'jquery-ui',
    'backbone',
    'underscore',
    'bizzabo/models/Global',
    'bizzabo/bzapi',
    'bizzabo/utils',
    'bizzabo/consts',
    'bizzabo/config',
    'bizzabo/views/FormMixin',
    'bizzabo/views/ModelBindingMixin',
    'bizzabo/views/main/MainView',
    'bizzabo/views/right/EditPartnerView',
    'bizzabo/views/right/EditTiersView',
    'bizzabo/views/main/sponsors/EditPartnersView',
    'bizzabo/views/main/sponsors/EditSplashView',
    'hbars!bizzabo/templates/sponsors'
], function(
    $,
    jQueryUI,
    Backbone,
    _,
    Global,
    BZAPI,
    UTILS,
    Consts,
    CONFIG,
    FormMixin,
    ModelBindingMixin,
    MainView,
    EditPartnerView,
    EditTiersView,
    EditPartnersView,
    EditSplashView,
    template
    ) {

    var SponsorsView = MainView.extend({

        tabClass : Consts.UI.tabClasses.SPONSORS,
        partners : undefined,

        prepare : function() {
            var eventId = this.model.get("id");
            this.partners = Global.modelPool.getPartners(eventId);
            this.servicePlan = Global.modelPool.getServicePlan(eventId);
            this.prepareModels([this.model, this.partners, this.servicePlan]);
        },

        remove : function() {
            this.removeMainView();
        },

        render : function() {
            this.renderSponsorsContentView();
        },

        renderSponsorsContentView : function() {
            this.renderMainView({
                hasDetails : true,
                detailsSizeClass : "width795"
            });
            this.putContentView(new SponsorsContentView({
                model : this.model,
                parentView : this,
                deepLinkParams : this.options.deepLinkParams
            }));
        },

        applyDeepLink : function(deepLink) {
            this.contentView && this.contentView.applyDeepLink(deepLink);
        }

    });

    var SponsorsContentView = Backbone.View.extend({

        events : {
            'click li' : 'renderSegmentedControl'
        },

        className : 'sponsorsTab',
        currentSubView : undefined,

        sponsors : undefined,
        servicePlan : undefined,

        initialize : function() {
            _.bindAll(this, 'renderSegmentedControl');

            var eventId = this.model.get("id");
            this.partners = Global.modelPool.getPartners(eventId);
            this.servicePlan = Global.modelPool.getServicePlan(eventId);

            Backbone.on(Consts.Notifications.mainPage.SPONSORS_PAGE_LOADED, this.onPageLoad, this);
            Backbone.on('editPartnerClicked', this.showEditPartner, this);
            Backbone.on('editTiersClicked', this.showEditTiers, this);
            Backbone.on('sponsorsRightPanelClosed', this.closeDetailsCompletely, this);

            this.listenTo(this.partners, 'partnersValidated', this.activePartnersValidated);
            this.activePartnersValidated(true);
        },

        remove : function() {
            Backbone.off(Consts.Notifications.mainPage.SPONSORS_PAGE_LOADED, this.onPageLoad, this);
            Backbone.off('editPartnerClicked', this.showEditPartner, this);
            Backbone.off('editTiersClicked', this.showEditTiers, this);
            Backbone.off('sponsorsRightPanelClosed', this.closeDetailsCompletely, this);
            this.stopListening();

            this.currentSubView && this.currentSubView.remove();
            Global.appView.mainView.removeRightPanelView();

            this.off();
            this.$el.remove();
        },

        // Partners Validation

        activePartnersValidated : function(isValid, model, errors) {
            var partners = this.partners;
            var partnerErrors = {
                sponsor : 0,
                exhibitor : 0
            };
            if (!isValid) {
                _.each(_.keys(errors), function(cid) {
                    var partner = partners.get(cid);
                    var partnerType = partner && partner.get('partner-type');
                    if (partnerType) {
                        partnerErrors[partnerType] += UTILS.leafCount(errors[cid]);
                    }
                });
            }
            this.renderTabError('sponsors', partnerErrors['sponsor']);
            this.renderTabError('exhibitors', partnerErrors['exhibitor']);
        },

        // Rendering

        renderTabError : function(tabClass, numberOfErrors) {
            var element = this.$('.segmentedControl li.' + tabClass + ' .error');
            if (element.length <= 0) {
                return;
            }
            if (numberOfErrors <= 0) {
                element.empty().addClass('hidden');
            } else {
                element.text(numberOfErrors).removeClass('hidden');
            }
        },

        render : function() {
            var extendedJSON = {
                event : this.model.toJSON(),
                servicePlan : this.servicePlan.toJSON()
            };
            var html = template(extendedJSON);
            this.$el.html(html);
            return this;
        },

        renderSegmentedControl : function(e) {
            var element = e && e.currentTarget && $(e.currentTarget);
            if (!element) {
                return;
            }

            var linkElement = element.find('a');
            var css = {
                'width' : linkElement.width(),
                'left' : linkElement.position().left
            };

            var shouldPerformAction = false;
            if (!this.currentSubView) {
                shouldPerformAction = true;
            }

            var isAlreadySelected = element.hasClass('selected');
            if (isAlreadySelected) {
                this.$('.segmentedControl span.marker').css(css);
            } else {
                this.$('.segmentedControl ul li').removeClass('selected');
                this.$('.segmentedControl span.marker').animate(css, 'fast', function() {
                    element.addClass('selected');
                });
                shouldPerformAction = true;
            }

            if (shouldPerformAction) {
                if (linkElement.hasClass('sponsorsEditButton')) {
                    this.showEditPartnersSection(true, e.deepLinkParams);
                } else if (linkElement.hasClass('exhibitorsEditButton')) {
                    this.showEditPartnersSection(false, e.deepLinkParams);
                } else if (linkElement.hasClass('splashEditButton')) {
                    this.showSplashSection();
                }
            }
            this.disableViewIfNeed();
        },

        onPageLoad : function() {
            var deepLinkParams = this.options.deepLinkParams;
            delete this.options.deepLinkParams;

            this.listenTo(Global.modelPool.getActiveEvent(), 'change:event-is-active', this.disableViewIfNeed);
            var tab = deepLinkParams.type || 'sponsors';

            this.renderSegmentedControl({
                currentTarget : this.$('.segmentedControl ul li.' + tab).get(0),
                deepLinkParams : deepLinkParams
            });

        },

        disableViewIfNeed : function() {
            if (Global.modelPool.getActiveEvent() && Global.modelPool.getActiveEvent().get('event-is-active')) {
                this.$('.editSponsorsBtns, .addNewSponsorBigBtn, .customUploadButton').toggleClass('hide', true);
            } else {
                this.$('.editSponsorsBtns, .addNewSponsorBigBtn, .customUploadButton').toggleClass('hide', false);
            }
        },

        // Sections

        showEditPartnersSection : function(isSponsors, deepLinkParams) {
            this.switchSubView(new EditPartnersView({
                model : this.model,
                parentView : this,
                isSponsors : isSponsors,
                deepLinkParams : deepLinkParams
            }), isSponsors ? this.$(".sponsorsEdit") : this.$(".exhibitorsEdit"));
        },

        showSplashSection : function() {
            this.switchSubView(new EditSplashView({
                model : this.model,
                parentView : this
            }), this.$(".splashEdit"));
        },

        switchSubView : function(newSubView, el) {
            if (this.currentSubView) {
                this.currentSubView.stopAnimation && this.currentSubView.stopAnimation();
                this.currentSubView.remove();
            }

            this.currentSubView = newSubView;
            el.html(this.currentSubView.render().el);
            this.currentSubView.rendered && this.currentSubView.rendered();
            this.currentSubView.startAnimation && this.currentSubView.startAnimation(undefined, true);
            this.options.parentView.hideDetails();
            this.options.parentView.removeRightPanelView();
        },

        // Form

        showEditTiers : function() {
            this.options.parentView.putRightPanelView(new EditTiersView({
                model : this.model,
                parentView : this
            }));
            this.options.parentView.showDetails();
            this.options.parentView.openDetails(true);
            this.options.parentView.$el.removeClass('width795 width0').addClass('width550');
        },

        showEditPartner : function(sponsor, deepLinkParams) {
            this.options.parentView.putRightPanelView(new EditPartnerView({
                model : sponsor,
                event : this.model,
                parentView : this,
                deepLinkParams : deepLinkParams
            }));
                this.options.parentView.showDetails();
            this.options.parentView.openDetails(true);
            this.options.parentView.$el.removeClass('width550 width0').addClass('width795');
        },

        closeDetailsCompletely : function() {
            this.options.parentView.$el.removeClass('width795 width550').addClass('width0');
        }

    });
    
    return SponsorsView;
    
});
